import DateInput from "../../../../components/UI/PageInput/DateInput";

function CustomDateSelector({ setValue, register, from, to, errors }) {
  return (
    <div className="cy-history-customDateSelector ">
      <div className="w-full">
        <DateInput
          label="From *"
          name={"from"}
          value={from}
          setValue={setValue}
          register={{
            ...register("from", {
              required: "Please select start date",
            }),
          }}
          error={errors.from}
          disableFutureDays={true}
        />
      </div>
      <div className="w-full">
        <DateInput
          label="To *"
          name={"to"}
          value={to}
          setValue={setValue}
          register={{
            ...register("to", {
              required: "Please select end date",
            }),
          }}
          error={errors.to}
          disableFutureDays={true}
        />
      </div>
    </div>
  );
}

export default CustomDateSelector;
